import { Injectable, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class Sidebar {
  private isOpenSignal = signal(false);
  private readonly http = inject(HttpClient);

  isOpen = this.isOpenSignal.asReadonly();

  toggle() {
    this.isOpenSignal.update((open) => !open);
  }

  open() {
    this.isOpenSignal.set(true);
  }

  close() {
    this.isOpenSignal.set(false);
  }

  logout(): Observable<any> {
    return this.http.post<any>(`${environment.apiPrefix}${environment.auth.logout}`, {});
  }
}
